exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current-dialog[data-v-390dceba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}.current-dialog span[data-v-390dceba]{width:80px;text-align:right}.current-dialog div[data-v-390dceba]{width:80%}.current-dialog .current-dialog-icon[data-v-390dceba]{position:absolute;right:10px;width:auto;top:12px}.current-dialog[data-v-390dceba] .el-input__inner{text-align:left}\n", ""]);

// exports
